import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '../../assets/img/consumption/road_icon.png'


const _hoisted_1 = { class: "road-container" }
const _hoisted_2 = { class: "left-road" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = { class: "right-road" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.count, (item) => {
        return (_openBlock(), _createBlock("div", {
          class: "road-item",
          key: item
        }, [
          _hoisted_3
        ]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_4, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.count, (item) => {
        return (_openBlock(), _createBlock("div", {
          class: "road-item",
          key: item
        }, [
          _hoisted_5
        ]))
      }), 128))
    ])
  ]))
}